<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a">CONTENTS</p>
<p class="toc"><a href="#/Text/foreword">Foreword, by John Boessenecker</a></p>
<p class="toc"><a href="#/Text/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Text/introduction">Introduction</a></p>
<p class="toc1"><a href="#/Text/chapter01">1. The First Murder Trial</a></p>
<p class="toc"><span href="#/Text/chapter02" title="Link target outside of Sample">2. Too Late to Stay</span></p>
<p class="toc"><span href="#/Text/chapter03" title="Link target outside of Sample">3. A Debt Repaid</span></p>
<p class="toc"><span href="#/Text/chapter04" title="Link target outside of Sample">4. A Wild Horse Murder</span></p>
<p class="toc"><span href="#/Text/chapter05" title="Link target outside of Sample">5. Brannan Bites a Bullet</span></p>
<p class="toc"><span href="#/Text/chapter06" title="Link target outside of Sample">6. A Film Pioneer Who Packed a Pistol</span></p>
<p class="toc"><span href="#/Text/chapter07" title="Link target outside of Sample">7. The Suicide that Wasn’t</span></p>
<p class="toc"><span href="#/Text/chapter08" title="Link target outside of Sample">8. Winery Owner’s Train Tragedy</span></p>
<p class="toc"><span href="#/Text/chapter09" title="Link target outside of Sample">9. The Last Lynching</span></p>
<p class="toc"><span href="#/Text/chapter10" title="Link target outside of Sample">10. The Last Public Execution</span></p>
<p class="toc"><span href="#/Text/chapter11" title="Link target outside of Sample">11. Bucking the System</span></p>
<p class="toc"><span href="#/Text/chapter12" title="Link target outside of Sample">12. A Cup of Joe</span></p>
<p class="toc"><span href="#/Text/chapter13" title="Link target outside of Sample">13. The Belle of Chiles Valley</span></p>
<p class="toc"><span href="#/Text/chapter14" title="Link target outside of Sample">14. A Solid Comfort Home Resort Murder?</span></p>
<p class="toc"><span href="#/Text/chapter15" title="Link target outside of Sample">15. A Mine Murder</span></p>
<p class="toc"><span href="#/Text/chapter16" title="Link target outside of Sample">16. A Man Who Went Sour</span></p>
<p class="toc"><span href="#/Text/chapter17" title="Link target outside of Sample">17. A Wild Ride</span></p>
<p class="toc"><span href="#/Text/chapter18" title="Link target outside of Sample">18. A Town’s Innocence Lost</span></p>
<p class="toc"><span href="#/Text/chapter19" title="Link target outside of Sample">19. A Day at the Lake Turns Deadly</span></p>
<p class="toc"><span href="#/Text/chapter20" title="Link target outside of Sample">20. The Crime that Froze Time</span></p>
<p class="toc"><span href="#/Text/chapter21" title="Link target outside of Sample">21. The Oldest Profession</span></p>
<p class="toc"><span href="#/Text/chapter22" title="Link target outside of Sample">22. The Great Escapes</span></p>
<p class="toc1"><span href="#/Text/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Text/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?25db1534